import axios from 'axios';
import { Url } from './constantUrl';
import getHeaders from './getHeaders';
import * as types from './types';
import { errorHandler } from './error/errorHandler.action';
import { notify } from '../services/notification';
import { HTTP_STATUS } from '../constants/httpsStatus/httpsStatus';

// Get Part Categories
export const getPartCategories = () => async (dispatch) => {
  const url = process.env.REACT_APP_API_URL + Url.PART_CATEGORY;
  const options = {
    method: 'GET',
    headers: getHeaders(),
    url: url
  };

  try {
    const response = await axios(options);
    if (response.status === HTTP_STATUS.SUCCESS) {
      dispatch({ type: types.GET_PART_CATEGORIES_SUCCESS, payload: response.data.data });
      return response.data.data;
    }
    return null;
  } catch (error) {
    errorHandler(error);
    return null;
  }
};

// Get Cap Color Codes by part category ID
export const getCapColorCodes = (partCategoryId) => async (dispatch) => {
  const url = `${process.env.REACT_APP_API_URL}${Url.COLOR_CODE}/${partCategoryId}`;
  const options = {
    method: 'GET',
    headers: getHeaders(),
    url: url
  };

  try {
    const response = await axios(options);
    if (response.status === HTTP_STATUS.SUCCESS) {
      dispatch({ type: types.GET_CAP_COLOR_CODES_SUCCESS, payload: response.data.data });
      return response.data.data;
    }
    return null;
  } catch (error) {
    errorHandler(error);
    return null;
  }
};




// Generate Unique IDs
export const generateUniqueIds = (data) => async (dispatch) => {
  const url = process.env.REACT_APP_API_URL +  Url.CREATE_UNIQUE_ID;
  const options = {
    method: 'POST',
    headers: getHeaders(),
    url: url,
    data: data
  };

  try {
    const response = await axios(options);
    if (response.status === HTTP_STATUS.SUCCESS || response.status === HTTP_STATUS.CREATED) {
      notify.success(response.data.message || 'Unique ID generation process has started');
      return response.data;
    }
    return null;
  } catch (error) {
    errorHandler(error);
    return null;
  }
};
